import React from 'react';
import { Link } from 'react-router-dom';

import { SummaryEntry } from 'main/changelog';
import formatDate from 'utils/format-date';

import { useStyles } from './styles';

type Props = {
    summaries: SummaryEntry[];
    id: string;
    className?: string;
};

const Summaries: React.FC<Props> = ({ summaries, id, className }) => {
    const { classes, cx } = useStyles();

    return (
        <aside className={cx(classes.root, className)}>
            {summaries.map((item) => {
                const active = item.id === id;
                return (
                    <Link key={item.id} to={`/changelog/${item.id}`} className={classes.item}>
                        <span className={cx(classes.title, active && classes._active)}>{item.title}</span>
                        <span className={classes.date}>{formatDate(item.date, 'MMMM d, yyyy')}</span>
                    </Link>
                );
            })}
        </aside>
    );
};

export default Summaries;
